module.exports = __webpack_public_path__ + "media/images/japan/big-early-bird-ecaab0378d364ec7a1e32a3292a5c1b8.png";